import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import Dashboard from "../../components/Dashboard/Dashboard";
import { useSnackbar } from "notistack";
import axios from "axios";
import "./Settings.css";
import Cookies from "js-cookie";
import { UserContext } from "../../components/UserContext";

const url = "https://www.bitmasta.io/php/functioned.php";
const Settings = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const user = useContext(UserContext);
  const [state, setState] = useState({
    firstName: "",
    password: "",
    conPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    setLoading(true);
    const { firstName, password, conPassword } = state;
    e.preventDefault();
    if (!firstName && !password && !conPassword) {
      setLoading(false);
      enqueueSnackbar("All fields are required", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    } else {
      let formData = new FormData();
      formData.append("Active_User", user.user || Cookies.get("auth"));
      formData.append("Account_Name", firstName);
      formData.append("Account_Password", password);
      formData.append("Account_Change", conPassword);
      try {
        axios.post(url, formData).then((res) => {
          setLoading(false);
          if (res.data.status === "Account Error")
            enqueueSnackbar(res.data.message, {
              variant: "error",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
          else if (res.data.status === "Account Details Changed") {
            enqueueSnackbar(res.data.message, {
              variant: "success",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
            setState({
              firstName: "",
              password: "",
              conPassword: "",
            });
          } else {
            enqueueSnackbar(res.data.message, {
              variant: "error",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
          }
        });
      } catch (err) {
        enqueueSnackbar(err, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    }
  };
  return (
    <Dashboard {...props} back={() => props.history.push("/dashboard")}>
      <Fade>
        <Row className="pt-2">
          <div className="col-md-12 col-sm-12">
            <div>
              <Col md={6} className="m-auto bts-settings-wrapper">
                <p className="med blueText b7">Settings</p>
                <form action="">
                  <div>
                    <input
                      type="text"
                      value={state.firstName}
                      onChange={(e) =>
                        setState({ ...state, firstName: e.target.value })
                      }
                      placeholder="first Name"
                    />
                  </div>
                  <div>
                    <input
                      value={state.password}
                      onChange={(e) =>
                        setState({ ...state, password: e.target.value })
                      }
                      type="password"
                      placeholder="Password"
                    />
                  </div>
                  <div>
                    <input
                      value={state.conPassword}
                      onChange={(e) =>
                        setState({ ...state, conPassword: e.target.value })
                      }
                      type="password"
                      placeholder="Change Password"
                    />
                  </div>
                  <button
                    disabled={loading}
                    onClick={handleChange}
                    className="w-100"
                  >
                    Update
                  </button>
                </form>
              </Col>
            </div>
          </div>
        </Row>
      </Fade>
    </Dashboard>
  );
};

export default Settings;
